<template>
  <v-card
    :disabled="admin.systemsLoading"
    loader-height="8"
    :loading="admin.systemsLoading"
    class=""
    rounded
    min-width="600"
  >
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      Systems
      <v-spacer></v-spacer>

      <v-icon>{{ app.systemIcon }}</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        @dblclick:row="showDialog"
        v-model="selectionModel"
        single-select
        dense
        :headers="systemListHeaders"
        :items="admin.systemList"
        show-select
        v-on:item-selected="updateSelection"
        :items-per-page="5"
      >
        <template v-slot:item.published="{ item }">
          <v-icon color="success" v-show="item.published">mdi-check</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewSystem"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    components: {},
    data() {
      return {
        systemListHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'NAME', value: 'name' },
          { text: 'DESCRIPTION', value: 'description' },
          { text: 'SYSTEM TYPE', value: 'systemType' },
          { text: 'PUBLISHED', value: 'published' }
        ]
      };
    },
    methods: {
      /**
       * Updates the dialog flag in state
       */
      showDialog: function () {
        this.$store.commit('admin/setShowEditSystemDialog', true);
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(true);
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedSystem', data.item);
          this.$store.dispatch('admin/getSubsystemsBySystemId', data.item.id);
        } else {
          this.$store.commit('admin/setSelectedSystem', null);
          this.$store.commit('admin/setSubsystemList', []);
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears child selection models
       */
      clearChildSelectionModels() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedSubsystemSelectionModel',
          value: null
        });
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedComponentSelectionModel',
          value: null
        });
        this.$store.commit('admin/setSubsystemList', []);
        this.$store.commit('admin/setComponentList', []);
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedSystemSelectionModel',
          value: null
        });
      },
      /**
       * Adds new system
       */
      addNewSystem() {
        this.$store.commit('admin/setSelectedSystem', {
          id: 'new',
          name: '',
          description: '',
          systemType: '',
          published: false
        });
        this.$store.commit('admin/setShowEditSystemDialog', true);
        // clear selection omdels
        this.clearChildSelectionModels();
        this.clearThisSelectionModel();
      }
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedSystemSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedSystemSelectionModel',
            value: value
          });
        }
      }
    }
  };
</script>

<style></style>
